export const REDUCER_NAME = "orderSlice";

export interface iOrder {
    id: string;
    order_id: string;
    customer_id: string; 
    vendor_id: string; 
    order_date: string; 
    status: string; 
    total_price: string; 
    payment_status: string; 
    payment_method: string; 
    shipping_method: string; 
    created_at: string; 
    updated_at: string; 
    orderType: string;
}


export interface OrderData {
    products: any;
    id: string;
    order_id: string;
    vendor_id: string;
    customer_id: string;
    customer_name: string;
    customer_email: string;
    customer_mobile: string;
    customer_profile: string | null;
    createdAt: string;
    order_date: string;
    status: string;
    total_price: string;
    total_items: number;
    payment_status: string;
    payment_method: string;
    shipping_method: string;
    created_at: string;
    updated_at: string;
    items: iOrderItem[];
    billingAddress: iAddress;
    shippingAddress: iAddress;
  }

export interface iOrderItem {
    [x: string]: string | number | string[] | undefined;
    order_id?: string;
    product_id?: string;
    quantity?: number;
    price?: string;
    discount?: string |number;
    total_price?: string;
    status?:string;
    product_image?:Array<string>;
}

export interface iAddress {
    gstNumber: string;
    order_id: string;
    name: string;
    mobile_number: string;
    country: string;
    state: string;
    city: string;
    zip_code: string;
    street_address: string;
}
export interface iUpdatedAddress {
    customerName: string; 
    phoneNumber: string; 
    country: string;
    state: string;
    city: string;
    zip: string;          
    street: string;       
}
export interface iCreateOrderAddress {
    name: string;
    mobile_number: string;
    country: string;
    state: string;
    city: string; 
    zip_code: string;
    street_address: string;
    gstNumber?: string;
    email?: string;
  }

  export interface iCreateOrder {
    vendor_id: string;
    customer_id: string;
    payment_status?: string;
    payment_method: string;
    shipping_method: string;
    status: string;
    orderType: string;
    refrenceNumber?: string;
  }
  
  export interface iCreateOrderItem {
    product_id: string;
    quantity: number;
    price: number;
    discount: number;
    total_price?: number;
    productImageId?: string;
  }
 export  interface iCreateOrderRequest {
    order: iCreateOrder;
    orderItems: iCreateOrderItem[];
    billingAddress: iCreateOrderAddress;
    shippingAddress: iCreateOrderAddress;
  }  
export interface iOrderResponse {
        order: iOrder;
        items: iOrderItem[];
        billingAddress: iAddress;
        shippingAddress: iAddress;
    };


export interface iOrderList {
    order: iOrder[]; 
}

export interface iOrderDataById {
    orders: OrderData; // Changed from iOrder to OrderData
  }
  

export interface iOrderState {
    isLoading: boolean;
    orders: OrderData | null; // `OrderData` type will store the order structure
    errorMessage: string | null;
    orderList: OrderData[];
    forwardItems:null;
  }
